<template>
  <div class="menu-page">
    <Nav
      :title="title"
      :chips="navHeaders"
    />
    <div>
      <Section
        v-for="section in partnersChapters"
        :key="section.slug"
        :section="section"
      />
    </div>
  </div>
  <SubscriptionBlock :analytics-api-url="VITE_RUNTIME_SOGU_SERVICE_URL" />
</template>

<script setup lang="ts">
  import { usePartnersStore } from '@/entities/partners/store/usePartnersStore';
  import Nav, { type IChip } from '@/widgets/Nav.vue';
  import Section from '@/widgets/Section.vue';
  import { SubscriptionBlock } from '@experience/subscription-block-package';
  import { useRuntimeConfig } from 'virtual:runtime-config';
  import { useHead } from '@unhead/vue';

  const title = 'Помощь партнёрам';

  useHead({
    title: `${title} — Tripster`,
  });

  const { VITE_RUNTIME_SOGU_SERVICE_URL } = useRuntimeConfig<false>();

  const partnersStore = usePartnersStore();
  const { partnersChapters } = storeToRefs(partnersStore);

  const navHeaders = computed<IChip[]>(
    () =>
      partnersChapters.value?.map((chapter) => ({
        name: chapter.title,
        link: chapter.slug,
      })) || [],
  );

  partnersStore.getPartnerChapters();
</script>

<style scoped lang="scss">
  .menu-page {
    max-width: 805px;
    margin: 0 auto;
    padding: 0 20px;
  }
</style>
